import React, { FC, ReactNode } from 'react';
import { Tooltip } from '@mui/material';

const MUIToolTip: FC<{ title: string; children: ReactNode; showTootip?: boolean; id?: string }> = ({
	title,
	children,
	showTootip = true,
	id = 'tooltip',
}) => {
	if (showTootip) {
		return (
			<Tooltip title={title} arrow placement='top' id={id}>
				<span style={{ maxWidth: 'fit-content' }} role='tooltip'>
					{children}
				</span>
			</Tooltip>
		);
	} else {
		return <>{children}</>;
	}
};

export default MUIToolTip;
